import classNames from "classnames";

import { Typography } from "../Typography";
import styles from "./Heading6.module.scss";

export const Heading6 = ({
  as = "h6",
  className,
  color,
  children,
  plain = false,
}) => (
  <Typography
    className={classNames(className, styles.element)}
    color={color}
    as={as}
    plain={plain}
  >
    {children}
  </Typography>
);
